import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserInfoService } from 'src/app/_services/userInfo.service';

@Injectable({ providedIn: 'root' })
export class TariffManagementService {
	acceptVersion = { 'Accept-Version': 'V2' };

	constructor(private commonService: CommonService, private http: HttpClient, readonly userInfoService: UserInfoService) {
	}

	getTariffByOperatorId(vendorId): Observable<any> {
		let headers = { headers: this.acceptVersion };
		return this.commonService.getCall(environment.API_BASE_PATH + `/tariffs/vendor/${vendorId}`, headers);
	}

	getTariffList(index, rows, column, direction, search): Observable<any> {
		let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search), 'Accept-Version': this.acceptVersion['Accept-Version'] } };
		return this.commonService.getCall(environment.API_BASE_PATH + '/tariffs', headers);
	}

	deleteTariff(id): Observable<any> {
		let headers = { headers: this.acceptVersion };
		return this.http.delete(environment.API_BASE_PATH + `/tariffs/${id}`, headers);
	}

	createTariff(val, timezone): Observable<any> {
		let headers = { headers: { 'Accept-Version': this.acceptVersion['Accept-Version'], 'X-Timezone': timezone } };
		return this.commonService.postCall(environment.API_BASE_PATH + '/tariffs', val, headers);
	}

	editTariff(val, id): Observable<any> {
		let headers = { headers: this.acceptVersion };
		return this.http.put(environment.API_BASE_PATH + `/tariffs/${id}`, val, headers);
	}

	getTariffById(id): Observable<any> {
		let headers = { headers: this.acceptVersion };
		return this.commonService.getCall(environment.API_BASE_PATH + `/tariffs/${id}`, headers);
	}
}